import * as actions from "./actions";

const initialState = {
	items: [],
	item: null,
	name: "",
	users: [],
	startAt: null,
	economicMode: true,
	emailSubject: "",
	emailMessage: "",
	smsMessage: "",
	whatsAppMessage: "",
	whatsAppRestrict: true,
	pushAction: 0,
	pushValue: "",
	pushTitle: "",
	pushMessage: "",
	errors: {},
	loading: {},
};

const reducer = function (state = initialState, { type, payload }) {
	switch (type) {
		case actions.CREATE_MARKETING: {
			return {
				...state,
				loading: { create: true },
				errors: initialState.errors,
			};
		}
		case actions.CREATE_MARKETING_SUCCESS: {
			return {
				...state,
				loading: { create: false },
				items: [payload, ...state.items],
				item: null,
				name: initialState.name,
				users: initialState.users,
				startAt: initialState.startAt,
				economicMode: initialState.economicMode,
				emailSubject: initialState.emailSubject,
				emailMessage: initialState.emailMessage,
				smsMessage: initialState.smsMessage,
				whatsAppMessage: initialState.whatsAppMessage,
				whatsAppRestrict: initialState.whatsAppRestrict,
				pushTitle: initialState.pushTitle,
				pushMessage: initialState.pushMessage,
				pushAction: initialState.pushAction,
				pushValue: initialState.pushValue,
			};
		}
		case actions.CREATE_MARKETING_FAILED: {
			return {
				...state,
				loading: { create: false },
				errors: payload,
			};
		}
		case actions.SET_VALUE: {
			return {
				...state,
				...payload,
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
